var map = {
	"./mijn-stad_horizontaal_green_de.svg": 88349,
	"./mijn-stad_horizontaal_green_en.svg": 67269,
	"./mijn-stad_horizontaal_green_fr.svg": 41484,
	"./mijn-stad_horizontaal_green_nl.svg": 12098
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 56254;